import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import api from "./api/axios";
import { useActivityLogger } from "./hooks/useActivity";
import { useSearch } from "./contexts/SearchContext";


export default function AdminUser() {
  const { searchQuery } = useSearch();
  const [admins, setAdmins] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;
  const navigate = useNavigate();
  const { logAdminActivity } = useActivityLogger();
  useEffect(() => {
    logAdminActivity(
      "view",
      "view_admin_user_list",
      "user",
      null,
      "admin",
      "success",
      "",
      "Admin membuka daftar pengguna"
    );
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const res = await api.get("/admins");
      setAdmins(res.data);
    } catch (err) {
      console.error("Gagal mengambil data admin", err);
    }
  };

  const handleDelete = async (id, username) => {
    const confirmed = window.confirm(
      `Yakin ingin menghapus admin dengan username '${username}'?`
    );
    if (!confirmed) return;

    try {
      await api.delete(`/admins/${id}`);
      alert(`Admin '${username}' berhasil dihapus.`);
      logAdminActivity(
        "delete",
        "delete_admin_user",
        "user",
        id,
        username,
        "success",
        "",
        `Admin menghapus pengguna ${username}`
      );
      fetchAdmins(); // refresh list
    } catch (err) {
      alert("Gagal menghapus admin.");
      console.error(err);
    }
  };
  const filteredAdmins = admins.filter(admin =>
    admin.username?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    admin.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    admin.nomor_hp?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAdmins.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredAdmins.length / itemsPerPage);

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-4 rounded shadow">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Admin</h2>
            <button
              onClick={() => navigate("/admin/adminlist/add")}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              + Tambah Admin
            </button>
          </div>

          <table className="w-full text-sm">
            <thead className="border-b">
              <tr>
                <th className="py-2 text-left">Username</th>
                <th className="py-2 text-left">E-mail</th>
                <th className="py-2 text-left">No. HP</th>
                <th className="py-2"></th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((admin) => (
                <tr key={admin.ID} className="border-b">
                  <td className="py-4">{admin.username}</td>
                  <td className="py-4">{admin.email}</td>
                  <td className="py-4">{admin.nomor_hp}</td>
                  <td className="py-4 align-middle">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() =>
                          navigate(`/admin/adminlist/edit/${admin.username}`)
                        }
                      >
                        <img
                          src="/icon-edit.png"
                          alt="Edit"
                          className="h-5 w-5"
                        />
                      </button>
                      <button
                        onClick={() => handleDelete(admin.ID, admin.username)}
                      >
                        <img
                          src="/icon-trash.png"
                          alt="Delete"
                          className="h-5 w-5"
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-4 gap-1">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="border px-2 py-1 rounded"
            >
              &lt;
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`border px-2 py-1 rounded ${
                  currentPage === i + 1 ? "bg-blue-500 text-white" : ""
                }`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              className="border px-2 py-1 rounded"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
